import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.powder,
  secondaryBgColor: colors.white,
  textColorDark: colors.metal,
  textColorLight: colors.white
};
export default imageSlider;